import { useState, useRef, useEffect } from "react";

const getValue = (preFilter, label) => {
    return label === "Source" && preFilter.includes(' - ') 
        ? preFilter.split(' - ')[1].trim() 
        : preFilter;
}

const SearchOptionsDropdown = ({ label, options, values = [], setFilter }) => {
    const [open, setOpen] = useState(false);
    const dropdownRef = useRef(null);

    const handleChange = (option) => {
        let newValue = getValue(option, label);

        // Remove the option
        if (values.includes(newValue)) {
            setFilter([...values.filter(v => v !== newValue)]);
        } else {
            // Add the option
            setFilter([...values, newValue]);
        }
    };

    // Close dropdown if clicked outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <div className="searchOptionBlock" ref={dropdownRef}>
            <i className="searchOptionBlockTitle" style={open ? {backgroundColor: "#dcd9d0", border: "1px solid #919191"} : {}} onClick={() => setOpen(o => !o)}>
                {label}{values.length !== 0 && <span style={{fontStyle: "normal", fontSize: "smaller", paddingLeft: "2px"}}> ({values.length})</span>}

                <svg width="16" height="16" viewBox="0 0 16 16" style={{
                    verticalAlign: "middle",
                    transition: "transform 0.2s",
                    transform: open ? "rotate(0deg)" : "rotate(90deg)"
                }}>
                    <polyline points="4,6 8,10 12,6" fill="none" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
            </i>
            
            {open && (
                <div className="searchOptionCheckboxListContainer" style={{ minWidth: label === "Source" ? "550px" : "150px"}}>
                    <ul className="searchOptionCheckboxList">
                        {options.map((option) => (
                            <li key={option} className="searchOptionCheckboxListItem">
                                <label style={{ cursor: "pointer" }}>
                                    <input
                                        className="searchOptionCheckbox"
                                        type="checkbox"
                                        checked={values.some(selectedFilter => {
                                            if(label === "Source") {
                                                return option.split(" - ")[1].toLowerCase() === selectedFilter.toLowerCase();
                                            }
                                            return option === selectedFilter;
                                        })}
                                        onChange={() => handleChange(option)}
                                    />
                                    {option}
                                </label>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
};

export default SearchOptionsDropdown;